import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  HeroContainer,
  InfoContainer,
} from './styled'

import coworking from 'assets/images/coworking.jpg'

const VenueHeader = ({ background }) => {

  if (background == null) {
    background = coworking
  }
  return (
    <Container>
      <HeroContainer elevation={0} background={background}>

        {/* Content for the Hero section */}
      </HeroContainer>

      <InfoContainer>
      </InfoContainer>
    </Container>

  )
}

VenueHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  avatar: PropTypes.string,
  background: PropTypes.string
}

export default VenueHeader
